export const blockIconsHomeBroadcastOnHome = (
	<span className='material-symbols-outlined'>broadcast_on_home</span>
);
